import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  url?: string
  autoplay?: number
}

function Youtube(props: Props) {
  const intl = useIntl()
  const { url, autoplay } = props
  const videoId = useMemo(() => {
    const match = url?.match(
      /(?:\/(?:channels\/[\w]+|(?:(?:album\/\d+|groups\/[\w]+)\/)?videos?))?\/(\d+)/i,
    )

    return match ? match[1] : null
  }, [url])

  if (!videoId) {
    return null
  }

  return (
    <iframe
      id="ytplayer"
      title={intl.formatMessage({
        id: 'N3I/nDQgBJ',
        defaultMessage: 'YouTube video player',
        description: 'Title for embedded YouTube video iframe',
      })}
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${videoId}?autoplay=${(autoplay || 0)}`}
      frameBorder="0"
    />
  )
}

export default Youtube
